import { Sheet } from './Sheet';
import { useStrings } from '../state/AppContext';

export interface AboutSheetProps {
  open: boolean;
  onClose: () => void;
}

export function AboutSheet({ open, onClose }: AboutSheetProps) {
  const t = useStrings();
  return (
    <Sheet open={open} title={t.about.title} onClose={onClose}>
      <div className="flex flex-col gap-3 pb-4 text-sm">
        <p className="font-semibold">{t.about.tagline}</p>
        <p className="text-dim">{t.about.body}</p>
        <p className="text-dim">{t.about.version}</p>
        <p className="text-dim">{t.about.privacy}</p>
        <p className="text-dim">
          {t.about.creditsEnglish}{' '}
          <a
            href="https://creativecommons.org/licenses/by-sa/4.0/"
            target="_blank"
            rel="noreferrer"
            className="underline"
          >
            CC BY-SA 4.0
          </a>
          .
        </p>
        <p className="text-dim">{t.about.creditsDutch}</p>
        <p className="text-dim">{t.about.wordLists}</p>
      </div>
    </Sheet>
  );
}
